// actions/partnerTypes.js
export const SET_PARTNER_CONFIG = 'SET_PARTNER_CONFIG';
